import { Resume } from '@sr/types';
import { useThemeUI } from 'theme-ui';
import { ResumeTheme } from '../common/base-theme';
import { getCalcSize } from '../common/calc-size';
import { Box, List, ListItem, SectionHeading, WebsiteLink } from '../common/ui';
import LeftBar from './LeftBar';

const ContactInfo = ({ resume }: { resume: Resume }) => {
  const theme = useThemeUI().theme as ResumeTheme;
  const calcSize = getCalcSize(theme.baseSize);
  const { city, email, phone, state, website, website2 } = resume.about;
  return (
    <Box variant="sectionContainer" as="section">
      <LeftBar width={20} mb={calcSize(1.5)}>
        <SectionHeading>Contact Info</SectionHeading>
      </LeftBar>
      <List
        sx={{
          listStyle: 'none',
          margin: 0,
          padding: 0,
        }}
      >
        <ListItem>
          {city}
          {city && state && ', '}
          {state}
        </ListItem>
        <ListItem>
          <WebsiteLink url={website} />
        </ListItem>
        {website2 && (
          <ListItem>
            <WebsiteLink url={website2} />
          </ListItem>
        )}
        <ListItem>{email}</ListItem>
        <ListItem>{phone}</ListItem>
      </List>
    </Box>
  );
};

export default ContactInfo;
